import { useContext, useMemo } from 'react'

import GeoContext from 'contexts/geoContext'
import { sortBy, uniqueBy } from 'lib/array/arrayUtils'
import useFlightDeals from 'hooks/Flights/useFlightDeals'

type FlightLocationDetails = [
  locations: {
    code: string;
    name: string;
  }[],
  defaultLocation: {
    code: string;
    name: string;
  } | undefined
]

function useFlightDealLocations(): FlightLocationDetails {
  const [flightDeals] = useFlightDeals()
  const { closestAirport } = useContext(GeoContext)

  const locations = useMemo(() => {
    const uniqueLocations = uniqueBy(
      flightDeals,
      (deal) => deal.originAirportCode,
    ).map((deal) => ({
      code: deal.originAirportCode,
      name: deal.originName,
    }))

    return sortBy(uniqueLocations, ({ name }) => name, 'asc')
  }, [flightDeals])

  const defaultLocation = useMemo(
    () => locations.find((location) => location.code === closestAirport.code) ?? locations[0],
    [locations, closestAirport],
  )

  return [locations, defaultLocation]
}

export default useFlightDealLocations
